module.exports = __webpack_public_path__ + "static/media/Logo.69094044.png";